import { render } from "./TabsPage.vue?vue&type=template&id=0e2e9d5c&scoped=true&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=0e2e9d5c&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2e9d5c"]])

export default __exports__